import {
  Box,
  Button,
  Modal,
  Grid,
  FormControl,
  TextField,
  Divider,
  Radio,
  FormControlLabel,
  RadioGroup,
  MenuItem,
  Select,
  Checkbox,
  FormGroup,
  FormHelperText
} from '@mui/material'
import React, { useState, useEffect } from 'react'
import { useTheme } from '@mui/material/styles'
import { styled } from '@mui/material/styles'
import CloseIcon from '@mui/icons-material/Close'
import {
  TextBold,
  TextRegular,
  TextSemiBold
} from '../../../commonComponents/TextStyling'

import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import moment from 'moment'
import { colorWithOpacity, isEmpty, showToast } from '../../../utils/AppHelper'
import serverData from '../../../api/ServerData'
import AppButton from '../../../commonComponents/AppButton'
import { getUserDetails } from '../../../utils/LocalStorage'
import TextEditor from '../../../commonComponents/TextEditor'
import appassets from '../../../utils/appassets'
import ImageComponent from '../../../commonComponents/ImageComponent'
import { useNavigate } from 'react-router-dom'
import { ENV } from '../../../ENV'

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
})

const responsiveStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  transform: 'translate(-0%, -0%)',
  bgcolor: 'white',
  boxShadow: 5,
  p: '32px 24px',
  height: '100%',
  overflow: 'auto',
  width: '100%'
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white',
  borderRadius: '16px',
  boxShadow: 5,
  p: '32px 24px',
  height: '80vh',
  overflow: 'auto',
  width: '75%'
}

export default function CandidateFormModal ({ data, matches }) {
  const navigate = useNavigate()
  const user = getUserDetails()
  var theme = useTheme()
  var { open, item, isEdit, onClose } = data

  const [candidateSubmitMail, setCandidateSubmitMail] = useState(false)
  const [loading, setLoading] = useState(false)

  const [firstname, setFirstname] = useState('')
  const [lastname, setLastname] = useState('')
  const [email, setEmail] = useState('')

  const [phone, setPhone] = useState('')
  const [resume, setResume] = useState(null)
  const [coverLetter, setCoverLetter] = useState(null)
  const [emailPreview, setEmailPreview] = useState('')

  const [formError, setFormError] = useState({})
  const [preScreenQues, setPreScreenQues] = useState([])
  const [jobDescription, setJobDescription] = useState('')

  const handleAnswerChange = (index, value) => {
    const questions = [...preScreenQues]
    questions[index].answer = value
    setPreScreenQues(questions)
  }

  const validateForm = () => {
    const error = {}
    if (isEmpty(firstname)) {
      error.firstname = 'Please enter first name.'
    }
    if (isEmpty(lastname)) {
      error.lastname = 'Please enter last name.'
    }
    if (isEmpty(email)) {
      error.email = 'Please enter email.'
    }
    if (isEmpty(phone)) {
      error.phone = 'Please enter phone number.'
    }
    if (isEmpty(resume)) {
      error.resume = 'Please provide resume.'
    }
    if (isEmpty(coverLetter) && isEmpty(jobDescription)) {
      error.coverLetter = 'Please provide cover letter.'
    }

    if (preScreenQues.length > 0) {
      for (let index = 0; index < preScreenQues.length; index++) {
        const element = preScreenQues[index]
        if (isEmpty(element.answer)) {
          if (!error.hasOwnProperty('preScreenQues')) {
            error.preScreenQues = {}
          }
          error.preScreenQues[index] = {
            answer: 'Please enter a answer'
          }
        }
      }
    }
    setFormError(error)
    return Object.keys(error).length === 0
  }

  useEffect(function () {
    if (isEdit) {
      setFirstname(item?.candidateFirstName)
      setLastname(item?.candidateLastName)
      setEmail(item?.candidateEmail)
      setPhone(item?.candidatePhone)
      setResume(item?.resumePath)
      setCoverLetter(item?.coverLetterPath)
      setJobDescription(item?.coverSummary)
    }
    setPreScreenQues([...item?.preScreenQuestions])
  }, [])

  const handleNextButton = () => {
    if (validateForm()) {
      setLoading(true)
      var body = {
        firstname: firstname,
        jobTitle: item?.jobTitle,
        companyname: item?.companyname,
        coverSummary: jobDescription,
        recruiterFirstName: user?.firstname,
        recruiterLastName: user?.lastname,
        preScreenQuestions: preScreenQues
      }
      serverData.candidatePostApplicationEmail(
        body,
        data => {
          if (data) {
            setEmailPreview(data)
            setCandidateSubmitMail(true)
          } else {
            showToast(data.message)
          }
          setLoading(false)
        },
        error => {
          setLoading(false)
          showToast(error.statusText)
        }
      )
    }
  }

  const handleCoverLetterChange = e => {
    const error = {}
    const file = e.target.files[0]
    const acceptFileType = [
      'application/pdf',
      'application/msword',
      'text/plain',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ]
    if (file && acceptFileType.includes(file.type)) {
      setCoverLetter(file)
    } else {
      error.coverLetter =
        'Please provide cover letter in pdf, word or text format'
      setCoverLetter(null)
    }
    setFormError(error)
  }

  const handleFileChange = e => {
    const error = {}
    const file = e.target.files[0]
    const acceptFileType = [
      'application/pdf',
      'application/msword',
      'text/plain',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ]

    if (file && acceptFileType.includes(file.type)) {
      setResume(file)
    } else {
      error.resume = 'Please provide resume in pdf, word or text format'
      setResume(null)
    }
    setFormError(error)
  }

  const handleSubmit = () => {
    setLoading(true)

    var formData = new FormData()
    if (isEdit) {
      formData.append('applicationId', item?.applicationId)
    }
    formData.append('jobId', item.jobId)
    formData.append('candidateFirstName', firstname)
    formData.append('candidateLastName', lastname)
    formData.append('candidateEmail', email)
    formData.append('candidatePhone', phone)
    if (resume?.name) {
      formData.append('resume', resume)
    }
    if (coverLetter?.name) {
      formData.append('coverletter', coverLetter)
    }
    if (jobDescription) {
      formData.append('coverSummary', jobDescription)
    }
    formData.append(
      'prescreenQue',
      preScreenQues.length > 0 ? JSON.stringify(preScreenQues) : ''
    )

    if (isEdit) {
      serverData.EditCandidate(
        formData,
        data => {
          if (data.status) {
            showToast(data.message, false)
            onClose(true)
          } else {
            showToast(data.message)
          }
          setLoading(false)
        },
        error => {
          setLoading(false)
          showToast(error.statusText)
        }
      )
    } else {
      serverData.submitCandidate(
        formData,
        data => {
          if (data.status) {
            showToast(data.message, false)
            onClose()
          } else {
            showToast(data.message)
          }
          setLoading(false)
        },
        error => {
          setLoading(false)
          showToast(error.statusText)
        }
      )
    }
  }

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box sx={matches ? responsiveStyle : style}>
          <CloseIcon
            onClick={onClose}
            style={{
              position: 'absolute',
              right: matches ? 16 : 4,
              top: matches ? 16 : 4,
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.background.paper,
              borderRadius: 20,
              fontSize: '24px',
              cursor: 'pointer'
            }}
          />
          <Grid container>
            {matches && (
              <Grid
                item
                xs={12}
                style={{
                  marginTop: '12px'
                }}
              >
                <TextSemiBold
                  style={{
                    cursor: 'pointer',
                    lineHeight: '24px',
                    color: theme.palette.primary.main
                  }}
                  onClick={() =>
                    navigate('/recruiter/newcompany', {
                      state: item
                    })
                  }
                >
                  {item.companyname}
                </TextSemiBold>
              </Grid>
            )}
            <Grid item xs={12}>
              <Grid container>
                <Grid
                  item
                  style={{
                    display: 'flex',
                    flexGrow: 1,
                    marginTop: matches && '8px'
                  }}
                >
                  <Grid
                    item
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      border: `1px solid ${theme.palette.border.main}`,
                      width: '57px',
                      height: '56px',
                      borderRadius: '16px',
                      overflow: 'hidden',
                      padding: '8px'
                    }}
                  >
                    <ImageComponent
                      alt='company logo'
                      src={item.profilePicture}
                      style={{}}
                    />
                  </Grid>
                  <Grid item style={{ paddingLeft: '16px' }}>
                    <Grid item xs={12}>
                      <TextBold
                        style={{
                          fontSize: '18px'
                        }}
                      >
                        {item.jobTitle}
                      </TextBold>
                    </Grid>

                    {!matches && (
                      <Grid
                        item
                        xs={12}
                        style={{
                          marginTop: '8px'
                        }}
                      >
                        <TextSemiBold
                          style={{
                            cursor: 'pointer',
                            lineHeight: '24px',
                            color: theme.palette.primary.main
                          }}
                          onClick={() =>
                            navigate('/recruiter/newcompany', {
                              state: item
                            })
                          }
                        >
                          {item.companyname} - {item.city},{item.countryName}
                        </TextSemiBold>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
                <Grid item xs={matches && 12}>
                  <Grid item style={{ marginTop: matches && '8px' }}>
                    <Grid
                      item
                      style={{
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      <img
                        src={`${appassets.location}`}
                        alt='location'
                        style={{ marginRight: '8px' }}
                      />
                      <TextRegular
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: '16px',
                          lineHeight: '24px',
                          color: theme.palette.text.secondary,
                          paddingRight: '16px'
                        }}
                      >
                        {item.city}, {item.state}, {item.countryName}
                      </TextRegular>
                    </Grid>
                  </Grid>
                  <Grid item style={{ marginTop: '8px' }}>
                    <Grid container direction={'row'}>
                      <Grid
                        item
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          flexGrow: 1
                        }}
                      >
                        <img
                          src={`${appassets.suitcase}`}
                          alt='suitcase'
                          style={{ marginRight: '8px' }}
                        />
                        <TextRegular
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: '16px',
                            lineHeight: '24px',
                            color: theme.palette.text.secondary,
                            paddingRight: '16px',
                            width: '6rem'
                          }}
                        >
                          {item.jobTypeName}
                        </TextRegular>
                      </Grid>
                      <Grid
                        item
                        style={{
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <img
                          src={`${appassets.time}`}
                          alt='time'
                          style={{ marginRight: '8px' }}
                        />
                        <TextRegular
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: '16px',
                            lineHeight: '24px',
                            color: theme.palette.text.secondary,
                            paddingRight: matches ? '0px' : '16px'
                          }}
                        >
                          {moment(item?.createdAt).fromNow()}
                        </TextRegular>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Divider
              style={{
                width: '100%',
                margin: matches ? '16px 0px' : '32px 0px'
              }}
            />

            {candidateSubmitMail !== true ? (
              <>
                <Grid
                  item
                  xs={12}
                  style={{
                    display: 'flex'
                  }}
                >
                  <Grid container style={{ display: 'flex' }}>
                    <Grid
                      item
                      xs={matches ? 12 : 6}
                      style={{ padding: '0px 16px' }}
                    >
                      <FormControl
                        fullWidth
                        margin='normal'
                        error={formError.firstname}
                      >
                        <TextRegular
                          style={{
                            color: theme.palette.text.secondary,
                            marginBottom: '6px'
                          }}
                        >
                          Candidate's First name
                        </TextRegular>
                        <TextField
                          id='First Name'
                          variant='outlined'
                          name='firstname'
                          value={firstname}
                          onChange={e => {
                            const { value } = e.target
                            if (value.length < 30) {
                              setFirstname(
                                e.target.value
                                  .replace(' ', '')
                                  .replace(/[^a-zA-z]/g, '')
                              )
                            }
                          }}
                          error={formError.firstname}
                          helperText={formError.firstname}
                        />
                      </FormControl>
                    </Grid>
                    <Grid
                      item
                      xs={matches ? 12 : 6}
                      style={{ padding: '0px 16px' }}
                    >
                      <FormControl
                        fullWidth
                        margin='normal'
                        error={formError.lastname}
                      >
                        <TextRegular
                          style={{
                            color: theme.palette.text.secondary,
                            marginBottom: '6px'
                          }}
                        >
                          Candidate's Last name
                        </TextRegular>
                        <TextField
                          id='Last Name'
                          variant='outlined'
                          fullWidth
                          name='lastname'
                          value={lastname}
                          onChange={e => {
                            const { value } = e.target
                            if (value.length < 30) {
                              setLastname(
                                e.target.value
                                  .replace(' ', '')
                                  .replace(/[^a-zA-z]/g, '')
                              )
                            }
                          }}
                          error={formError.lastname}
                          helperText={formError.lastname}
                        />
                      </FormControl>
                    </Grid>
                    <Grid
                      item
                      xs={matches ? 12 : 6}
                      style={{ padding: '0px 16px' }}
                    >
                      <FormControl
                        fullWidth
                        margin='normal'
                        error={formError.email}
                      >
                        <TextRegular
                          style={{
                            color: theme.palette.text.secondary,
                            marginBottom: '6px'
                          }}
                        >
                          Candidate's Email address
                        </TextRegular>
                        <TextField
                          id='email'
                          variant='outlined'
                          fullWidth
                          name='email'
                          value={email}
                          onChange={e => {
                            var { value } = e.target
                            if (value.length < 60) {
                              setEmail(value)
                            }
                          }}
                          onBlur={() => {
                            serverData.checkCandiate(
                              { jobId: item?.jobId, email: email },
                              data => {
                                if (data.response.isExist) {
                                  setFormError({
                                    email: 'Candidate already exist'
                                  })
                                } else {
                                  setFormError({
                                    email: ''
                                  })
                                }
                              },
                              error => {
                                showToast(error.statusText)
                              }
                            )
                          }}
                          error={formError.email}
                          helperText={formError.email}
                        />
                      </FormControl>
                    </Grid>
                    <Grid
                      item
                      xs={matches ? 12 : 6}
                      style={{ padding: '0px 16px' }}
                    >
                      <FormControl
                        fullWidth
                        margin='normal'
                        error={formError.phone}
                      >
                        <TextRegular
                          style={{
                            color: theme.palette.text.secondary,
                            marginBottom: '6px'
                          }}
                        >
                          Candidate's Phone number
                        </TextRegular>
                        <TextField
                          id='phone'
                          variant='outlined'
                          fullWidth
                          name='phone'
                          value={phone}
                          onChange={e => {
                            var { value } = e.target
                            if (value.length < 11) {
                              const input = value.replace(/\D/g, '')
                              setPhone(input)
                            }
                          }}
                          error={formError.phone}
                          helperText={formError.phone}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                <Divider
                  style={{
                    width: '100%',
                    margin: '32px 0px',

                    height: '1px'
                  }}
                />
                <Grid
                  item
                  xs={12}
                  style={{
                    display: 'flex'
                  }}
                >
                  <Grid
                    container
                    style={{ display: 'flex', flexDirection: 'row' }}
                  >
                    <Grid
                      item
                      xs={matches ? 6 : 4}
                      style={{ padding: '0px 16px' }}
                    >
                      <FormControl fullWidth margin='normal'>
                        <TextRegular
                          style={{
                            color: theme.palette.text.secondary,
                            marginBottom: '6px'
                          }}
                        >
                          Upload resume
                        </TextRegular>
                        <TextField
                          placeholder='Upload .pdf/.docx file'
                          size='small'
                          value={
                            resume
                              ? (resume && resume.name) ||
                                item?.candidateFirstName + '-Resume'
                              : ''
                          }
                          // to-do if we use cross btn indide the TF to empty the state of resume
                          // InputProps={{
                          //   endAdornment: (
                          //     <InputAdornment
                          //       onClick={() => setResume('')}
                          //       position='end'
                          //     >
                          //       <CloseIcon />
                          //     </InputAdornment>
                          //   )
                          // }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid
                      item
                      xs={matches ? 6 : 4}
                      style={{
                        padding: '0px',
                        display: 'flex',
                        alignItems: 'flex-end'
                      }}
                    >
                      <FormControl
                        fullWidth
                        margin='normal'
                        error={formError.resume}
                      >
                        <Button
                          component='label'
                          role={undefined}
                          variant='contained'
                          tabIndex={-1}
                          startIcon={<CloudUploadIcon />}
                          style={{
                            textTransform: 'none',
                            width: 'fit-content'
                          }}
                        >
                          Attach Resume
                          <VisuallyHiddenInput
                            type='file'
                            accept='.pdf, .doc, .docx, .txt'
                            onChange={handleFileChange}
                          />
                        </Button>
                        <FormHelperText>{formError.resume}</FormHelperText>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Divider
                  style={{
                    width: '100%',
                    margin: '32px 0px',

                    height: '1px'
                  }}
                />

                <Grid item xs={12} style={{ display: 'flex' }}>
                  <Grid
                    container
                    style={{ display: 'flex', flexDirection: 'row' }}
                  >
                    <Grid
                      item
                      xs={matches ? 6 : 4}
                      style={{ padding: '0px 16px' }}
                    >
                      <FormControl fullWidth margin='normal'>
                        <TextRegular
                          style={{
                            color: theme.palette.text.secondary,
                            marginBottom: '6px'
                          }}
                        >
                          Cover letter
                        </TextRegular>
                        <TextField
                          placeholder='Upload .pdf/.docx file'
                          size='small'
                          value={
                            coverLetter
                              ? (coverLetter && coverLetter.name) ||
                                item?.candidateFirstName + '-Cover Letter'
                              : ''
                          }
                          // to-do if we use cross btn indide the TF to empty the state of coverLetter
                          // InputProps={{
                          //   endAdornment: (
                          //     <InputAdornment
                          //       onClick={() => setCoverLetter('')}
                          //       position='end'
                          //     >
                          //       <CloseIcon />
                          //     </InputAdornment>
                          //   )
                          // }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid
                      item
                      xs={matches ? 6 : 4}
                      style={{
                        padding: '0px',
                        display: 'flex',
                        alignItems: 'flex-end'
                      }}
                    >
                      <FormControl
                        fullWidth
                        margin='normal'
                        error={formError.coverLetter}
                      >
                        <Button
                          component='label'
                          role={undefined}
                          variant='contained'
                          tabIndex={-1}
                          startIcon={<CloudUploadIcon />}
                          style={{
                            textTransform: 'none',
                            width: 'fit-content'
                          }}
                        >
                          Attach cover letter
                          <VisuallyHiddenInput
                            type='file'
                            accept='.pdf, .doc, .docx, .txt'
                            onChange={handleCoverLetterChange}
                          />
                        </Button>
                        <FormHelperText>{formError.coverLetter}</FormHelperText>
                      </FormControl>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        margin: '24px 0px',
                        padding: '0px 16px'
                      }}
                    >
                      <TextBold style={{ fontWeight: 800 }}>OR</TextBold>
                    </Grid>

                    <Grid item xs={12} style={{ padding: '0px 16px' }}>
                      <FormControl
                        fullWidth
                        margin='normal'
                        error={formError.coverLetter}
                        style={{ margin: '0px' }}
                      >
                        <TextEditor
                          getter={jobDescription}
                          setter={setJobDescription}
                          placeholder={'Copy and paste the cover letter here.'}
                        />

                        <FormHelperText>{formError.coverLetter}</FormHelperText>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Divider
                  style={{
                    width: '100%',
                    margin: '32px 0px',
                    height: '1px'
                  }}
                />
                <Grid
                  item
                  xs={12}
                  style={{
                    display: 'flex'
                  }}
                >
                  {preScreenQues.length > 0 ? (
                    <Grid
                      container
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        paddingBottom: '10px'
                      }}
                    >
                      <Grid item xs={12}>
                        <TextBold style={{ fontWeight: 800 }}>
                          Pre screen
                        </TextBold>
                      </Grid>
                      <Grid item xs={12}>
                        {preScreenQues?.map((que, index) => (
                          <Grid item key={index}>
                            <Grid item xs={12}>
                              <TextRegular
                                style={{
                                  lineHeight: '2.5rem',
                                  color: theme.palette.text.secondary
                                }}
                              >
                                {index + 1}. {que.question}
                              </TextRegular>
                            </Grid>
                            <Grid item xs={12}>
                              <TextRegular
                                style={{ color: theme.palette.text.secondary }}
                              >
                                {que.type === 'textfield' && (
                                  <TextField
                                    placeholder='Answer'
                                    fullWidth
                                    value={que?.answer}
                                    sx={{
                                      input: {
                                        color: theme.palette.text.secondary
                                      }
                                    }}
                                    style={{ paddingRight: '10px' }}
                                    onChange={e => {
                                      var { value } = e.target
                                      if (value.length < 500) {
                                        handleAnswerChange(
                                          index,
                                          e.target.value
                                        )
                                      }
                                    }}
                                    error={
                                      formError.hasOwnProperty('preScreenQues')
                                        ? formError?.preScreenQues[index]
                                            ?.answer
                                        : false
                                    }
                                    helperText={
                                      formError.hasOwnProperty('preScreenQues')
                                        ? formError?.preScreenQues[index]
                                            ?.answer
                                        : ''
                                    }
                                  />
                                )}
                                {que.type === 'radio' && (
                                  <FormControl
                                    error={
                                      formError.hasOwnProperty('preScreenQues')
                                        ? formError?.preScreenQues[index]
                                            ?.answer
                                        : false
                                    }
                                  >
                                    <RadioGroup
                                      row
                                      name='row-radio-buttons-group'
                                      onChange={e =>
                                        handleAnswerChange(
                                          index,
                                          e.target.value
                                        )
                                      }
                                      value={que?.answer}
                                    >
                                      {que?.options?.map((opt, index) => (
                                        <FormControlLabel
                                          value={opt.name}
                                          control={<Radio />}
                                          label={opt.name}
                                        />
                                      ))}
                                    </RadioGroup>
                                    <FormHelperText>
                                      {formError.hasOwnProperty('preScreenQues')
                                        ? formError?.preScreenQues[index]
                                            ?.answer
                                        : ''}
                                    </FormHelperText>
                                  </FormControl>
                                )}
                                {que.type === 'dropdown' && (
                                  <FormControl
                                    error={
                                      formError.hasOwnProperty('preScreenQues')
                                        ? formError?.preScreenQues[index]
                                            ?.answer
                                        : false
                                    }
                                    style={{ width: '50%' }}
                                  >
                                    <Select
                                      labelId='demo-simple-select-label'
                                      id='demo-simple-select'
                                      onChange={e =>
                                        handleAnswerChange(
                                          index,
                                          e.target.value
                                        )
                                      }
                                      style={{
                                        color: theme.palette.text.secondary
                                      }}
                                    >
                                      {que?.options?.map((opt, index) => (
                                        <MenuItem
                                          key={index}
                                          value={opt.name}
                                          style={{
                                            color: theme.palette.text.secondary
                                          }}
                                        >
                                          {opt.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                    <FormHelperText>
                                      {formError.hasOwnProperty('preScreenQues')
                                        ? formError?.preScreenQues[index]
                                            ?.answer
                                        : ''}
                                    </FormHelperText>
                                  </FormControl>
                                )}
                                {que.type === 'checkbox' && (
                                  <FormControl
                                    component={'fieldset'}
                                    error={
                                      formError.hasOwnProperty('preScreenQues')
                                        ? formError?.preScreenQues[index]
                                            ?.answer
                                        : false
                                    }
                                  >
                                    <FormGroup>
                                      {que?.options?.map((opt, oIndex) => {
                                        var isChecked = que?.answer
                                          ?.split('::')
                                          ?.includes(opt.name)
                                        return (
                                          <FormControlLabel
                                            key={oIndex}
                                            control={
                                              <Checkbox
                                                value={opt.name}
                                                checked={isChecked}
                                                onChange={e => {
                                                  var { value } = e.target
                                                  if (isChecked) {
                                                    var arr =
                                                      que?.answer?.split('::')
                                                    var i = arr?.findIndex(
                                                      e => e == value
                                                    )
                                                    arr.splice(i, 1)
                                                    value = arr.join('::')
                                                  } else {
                                                    if (
                                                      que?.answer &&
                                                      que?.answer !== ''
                                                    ) {
                                                      value =
                                                        que?.answer +
                                                        '::' +
                                                        value
                                                    }
                                                  }
                                                  handleAnswerChange(
                                                    index,
                                                    value
                                                  )
                                                }}
                                                name={opt.name}
                                              />
                                            }
                                            label={opt.name}
                                          />
                                        )
                                      })}
                                    </FormGroup>
                                    <FormHelperText>
                                      {formError.hasOwnProperty('preScreenQues')
                                        ? formError?.preScreenQues[index]
                                            ?.answer
                                        : ''}
                                    </FormHelperText>
                                  </FormControl>
                                )}
                              </TextRegular>
                            </Grid>
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                  ) : null}
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{
                    margin: '10px 16px 10px 10px',
                    display: 'flex'
                  }}
                >
                  <Grid
                    container
                    spacing={2}
                    style={{ display: 'flex', flexDirection: 'row' }}
                  >
                    <Grid item>
                      <AppButton
                        variant='contained'
                        onClick={() => handleNextButton()}
                        name='Next'
                        disabled={false}
                        loading={loading}
                        style={{
                          textTransform: 'none',
                          fontSize: '16px',
                          padding: '12px 32px'
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <Button
                        variant='outlined'
                        onClick={() => onClose()}
                        style={{
                          textTransform: 'none',
                          fontSize: '16px',
                          padding: '12px 32px'
                        }}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            ) : (
              <>
                <Grid
                  item
                  xs={12}
                  style={{
                    border: `1px solid ${theme.palette.border.main} `,
                    margin: matches ? 0 : '10px 16px 10px 16px',
                    borderRadius: '4px',
                    display: 'flex'
                  }}
                >
                  <Grid container style={{ display: 'flex' }}>
                    <Grid
                      item
                      xs={12}
                      style={{
                        border: `1px solid ${theme.palette.border.main} `,
                        margin: '10px 16px 30px 10px',
                        display: 'flex',
                        flexDirection: 'column',
                        padding: '10px',
                        borderRadius: '8px',
                        backgroundColor: colorWithOpacity(
                          theme.palette.primary.main,
                          0.1
                        )
                      }}
                    >
                      <TextRegular>
                        We will send this email to {firstname} to confirm the
                        submission details and set-up candidate ownership for
                        you in the {ENV.product_name} database.
                      </TextRegular>
                      <TextRegular>
                        We would like you to review this email. At the bottom of
                        this page, you will have to options to go back and edit
                        the application.
                      </TextRegular>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{
                        border: `1px solid ${theme.palette.border.main} `,
                        margin: matches ? 0 : '10px 16px 10px 10px',
                        display: 'flex',
                        flexDirection: 'column',
                        padding: '0px 10px',
                        borderRadius: '0px',
                        backgroundColor: `${theme.palette.border.main}`
                      }}
                    >
                      <Grid
                        item
                        style={{
                          border: `1px solid ${theme.palette.primary.main} `,
                          margin: matches ? 0 : '0px 5rem',
                          display: 'flex',
                          flexDirection: 'column',
                          padding: '10px 20px',
                          backgroundColor: colorWithOpacity(
                            theme.palette.primary.main,
                            0.1
                          )
                        }}
                      >
                        <TextRegular>
                          {item?.jobTitle}, {item?.state}, {item?.countryName} [
                          {item?.workLocationTypeName}]
                        </TextRegular>
                      </Grid>

                      <Grid
                        item
                        style={{
                          border: `0px`,
                          margin: matches ? 0 : '0px 5rem',
                          display: 'flex',
                          flexDirection: 'column',
                          backgroundColor: `${theme.palette.background.paper}`
                        }}
                      >
                        <div disabled={true}>
                          <Box
                            pt={3}
                            pr={4}
                            pb={3}
                            pl={4}
                            dangerouslySetInnerHTML={{ __html: emailPreview }}
                          />
                        </div>
                      </Grid>
                      <Grid
                        item
                        style={{
                          border: `0px`,
                          margin: matches ? 0 : '0px 5rem',
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'center'
                        }}
                      >
                        <Grid
                          item
                          style={{
                            margin: '10px'
                          }}
                        >
                          <Button
                            disabled={loading}
                            variant='contained'
                            style={{ textTransform: 'none' }}
                            onClick={() => setCandidateSubmitMail(false)}
                          >
                            Go Back
                          </Button>
                        </Grid>
                        <Grid
                          item
                          style={{
                            margin: '10px'
                          }}
                        >
                          <AppButton
                            variant='contained'
                            onClick={() => handleSubmit()}
                            name='Submit Application'
                            disabled={false}
                            loading={loading}
                            style={{ textTransform: 'none' }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}
          </Grid>
        </Box>
      </Modal>
    </>
  )
}
